"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Helpers = __importStar(require("./Helpers"));
var lodash_1 = __importDefault(require("lodash"));
var Point = qed.Point, Range = qed.Range;
var assert = Helpers.assert;
var AttributeStack = (function () {
    function AttributeStack() {
        this.stack = [{}];
    }
    AttributeStack.prototype.push = function () {
        var newHead = lodash_1.default.clone(this.stack[this.stack.length - 1]);
        this.stack.push(newHead);
        return newHead;
    };
    AttributeStack.prototype.pop = function () {
        assert(this.stack.length > 1, "cannot pop empty attrstack");
        return this.stack.pop();
    };
    AttributeStack.prototype.pushAttrs = function (attrs) {
        var newHead = this.push();
        lodash_1.default.assign(newHead, attrs);
        return newHead;
    };
    AttributeStack.prototype.head = function () {
        return this.stack[this.stack.length - 1];
    };
    return AttributeStack;
}());
var Tokenizer = (function () {
    function Tokenizer(range) {
        this.range = range;
        this.tokens = [];
        this.elemLeavers = [];
        this.inlineAttrs = new AttributeStack();
        this.blockAttrs = new AttributeStack();
        this.listLevel = 0;
        var iterator = range.iterateRight();
        while (true) {
            var element = iterator.enterElement();
            if (element) {
                var skip = this.processEnterElement(element);
                if (skip) {
                    iterator.leaveElement();
                }
                continue;
            }
            var textRange = iterator.skipText();
            if (textRange) {
                this.processText(textRange);
                continue;
            }
            element = iterator.leaveElement();
            if (element) {
                this.processLeaveElement(element);
                continue;
            }
            if (iterator.isAtEnd()) {
                break;
            }
            else {
                var error = new Error("Pasted data broke our DOM iterator");
                error.extra = element != null ? element.innerHTML : undefined;
                throw error;
            }
        }
    }
    Tokenizer.prototype.processEnterElement = function (elem) {
        var _this = this;
        var head;
        var tagName = elem.tagName.toLowerCase();
        var widgetModelStr = elem.getAttribute("qwilr-widget-model");
        if (widgetModelStr) {
            var widgetModel = JSON.parse(widgetModelStr);
            delete widgetModel.id;
            this.mergeToken({ type: "widget", model: widgetModel });
            return true;
        }
        else if (tagName === "style") {
            return true;
        }
        var isBreak = tagName === "br" && !Array.from(elem.classList).includes("Apple-interchange-newline");
        var isBlock = isBreak || isVisualBlock(elem);
        var isTable = tagName === "table";
        if (isBlock) {
            head = this.blockAttrs.push();
            if (isBreak) {
                head.isBreak = true;
            }
            else if (tagName === "ul" || tagName === "ol") {
                head.bulletStyle = tagName;
                this.listLevel += 1;
                head.listLevel = this.listLevel;
            }
            else if (isFancyBlock(elem)) {
                head.blockType = tagName;
            }
            if (head.blockType === "li") {
                if (!head.bulletStyle) {
                    head.bulletStyle = "ul";
                }
                if (!head.listLevel) {
                    head.listLevel = 1;
                }
            }
            var tok = lodash_1.default.assign({ type: "block" }, head);
            this.mergeToken(tok);
        }
        else if (isTable) {
            var tok = this.processTable(elem);
            if (tok) {
                this.mergeToken(tok);
            }
            return true;
        }
        else {
            this.pushInlineAttrs(elem);
        }
        this.elemLeavers.push(function () {
            if (isBlock) {
                if (tagName === "ul") {
                    _this.listLevel -= 1;
                }
                _this.blockAttrs.pop();
                var token = lodash_1.default.assign({ type: "block" }, _this.blockAttrs.head());
                _this.mergeToken(token);
            }
            else {
                _this.inlineAttrs.pop();
            }
        });
        return false;
    };
    Tokenizer.prototype.processLeaveElement = function (elem) {
        if (this.elemLeavers.length === 0) {
            if (isVisualBlock(elem)) {
                var token = lodash_1.default.assign({ type: "block" });
                this.mergeToken(token);
            }
            return;
        }
        assert(this.elemLeavers.length > 0);
        var func = this.elemLeavers.pop();
        if (!(func instanceof Function)) {
            throw new Error(typeof func);
        }
        return func();
    };
    Tokenizer.prototype.processText = function (textRange) {
        var text = textRange.getText().trim();
        var last = this.tokens[this.tokens.length - 1];
        if (text.length > 0 || (last != null && !(last.type === "widget" || last.type === "block"))) {
            return this.mergeToken({
                type: "text",
                attrs: this.inlineAttrs.head(),
                text: textRange.getText(),
            });
        }
    };
    Tokenizer.prototype.processTable = function (elem) {
        var tok = {
            type: "block",
            blockType: "table",
            cells: [],
        };
        var rows = elem.querySelectorAll("tr");
        if (rows.length === 0) {
            return null;
        }
        for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
            tok.cells.push([]);
            var row = rows.item(rowIndex);
            var cells = row.querySelectorAll("td,th");
            for (var cellIndex = 0; cellIndex < cells.length; cellIndex++) {
                tok.cells[rowIndex].push([]);
                var cell = cells.item(cellIndex);
                var start = Point.start(cell);
                var end = Point.end(cell);
                var selection = new Range(start, end);
                var tokenizer = new Tokenizer(selection);
                tok.cells[rowIndex][cellIndex] = tokenizer.tokens;
            }
        }
        var columnCount = Math.max.apply(Math, __spreadArray([], __read(tok.cells.map(function (row) { return row.length; })), false));
        for (var rowIndex = 0; rowIndex < tok.cells.length; rowIndex++) {
            var row = tok.cells[rowIndex];
            var paddingCells = Array.from(Array(columnCount - row.length)).map(function () { return []; });
            tok.cells[rowIndex] = row.concat(paddingCells);
        }
        return tok;
    };
    Tokenizer.prototype.pushInlineAttrs = function (elem) {
        var computedStyle = hackComputedStyle(elem);
        var attrs = {};
        for (var name in Helpers.inlineAttributes) {
            var mapper = Helpers.inlineAttributes[name];
            var attrVal = mapper.read(elem, computedStyle);
            if (attrVal && attrVal !== supportedAttributes[name]) {
                attrs[name] = attrVal;
            }
        }
        return this.inlineAttrs.pushAttrs(attrs);
    };
    Tokenizer.prototype.mergeToken = function (tok) {
        var lastToken = this.tokens[this.tokens.length - 1];
        var isWidgetAndLastIsntBlock = tok.type === "widget" && (lastToken != null ? lastToken.type : undefined) !== "block";
        var eitherIsText = tok.type === "text" || (lastToken != null ? lastToken.type : undefined) === "text";
        var bothAreTextWithSameAttrs = tok.type === "text" &&
            (lastToken != null ? lastToken.type : undefined) === "text" &&
            lodash_1.default.isEqual(tok.attrs, lastToken.attrs);
        var dontMerge = !lastToken ||
            tok.isBreak ||
            isWidgetAndLastIsntBlock ||
            lastToken.type === "widget" ||
            (eitherIsText && !bothAreTextWithSameAttrs) ||
            lastToken.blockType === "table";
        delete tok.isBreak;
        if (dontMerge) {
            this.tokens.push(tok);
            return;
        }
        assert(lastToken.type === "block" || lastToken.type === "text");
        if (tok.blockType) {
            this.tokens[this.tokens.length - 1] = tok;
        }
        else if (tok.type === "text") {
            this.tokens[this.tokens.length - 1].text += tok.text;
        }
        else if (tok.type === "widget" && lastToken.type === "block") {
            this.tokens.pop();
            this.tokens.push(tok);
        }
    };
    Tokenizer.prototype.createBasicBlockToken = function (type) {
        return {
            blockType: type,
            type: "block",
        };
    };
    return Tokenizer;
}());
exports.default = Tokenizer;
var isVisualBlock = function (elem) { return Helpers.isBlock(elem); };
var fancyElems = ["li", "blockquote", "h1", "h2"];
var isFancyBlock = function (elem) {
    var tagName = elem.tagName.toLowerCase();
    return Array.from(fancyElems).includes(tagName);
};
var supportedAttributes = {
    "font-weight": "normal",
    "font-style": "normal",
    "text-decoration-line": "none",
    href: null,
};
function hackComputedStyle(elem) {
    var util = qed.util;
    var computed = util.computedStyle(elem, window);
    if (!computed["font-weight"]) {
        computed = util.shallowCopy(supportedAttributes);
        if (util.isElemType(elem, "i")) {
            computed["font-style"] = "italic";
        }
        if (util.isElemType(elem, "b")) {
            computed["font-weight"] = "bold";
        }
        if (util.isElemType(elem, "s")) {
            computed["text-decoration-line"] = "line-through";
        }
    }
    return computed;
}
